import { render, staticRenderFns } from "./Bongo.vue?vue&type=template&id=8bf88a60&"
import script from "./Bongo.vue?vue&type=script&lang=js&"
export * from "./Bongo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports